<script setup lang="ts">
import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {healthcenterUserApi} from "@/container";
import CustomerRemoteCertification
    from "@/customer/components/customer-remote-certification/CustomerRemoteCertification.vue";
import {ref, watch} from "vue";
import dateHelper from "@/core/helpers/dateHelper";
import HeaderBackButton from "@/core/components/header-back-button/HeaderBackButton.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardHeader from "@/core/components/base/BaseCardHeader.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {useRoute} from "vue-router";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";

const params = {
    certification_status: 'pending'
};

const modalVisible = ref(false);
const userToCertify = ref();
const route = useRoute();
const {data, isLoading} = useSwr(
    cacheKey('healthcenter/users', params),
    () => healthcenterUserApi().index(params)
);

watch(() => route.query, () => {
    if (route.query.first_name && route.query.last_name) {
        const user = data.value?.find(u => u.first_name === route.query.first_name && u.last_name === route.query.last_name);
        if (user) {
            userToCertify.value = user;
            modalVisible.value = true;
        }
    }
}, {immediate: true});

const headers = [
    {
        title: "Nom",
        key: 'last_name',
        value: (item) => item.last_name
    },
    {
        title: "Prénom",
        key: 'first_name',
        value: (item) => item.first_name
    },
    {
        title: "Inscription",
        key: 'created_at',
        value: (item) => dateHelper.mediumFormat(item.created_at)
    },
    {
        title: "",
        key: "action",
        maxWidth: "200px",
        sortable: false
    }
];

const handleRowPress = (item) => {
    userToCertify.value = item;
    modalVisible.value = true;
};
</script>

<template>
  <div>
    <HeaderBackButton title="Patients en attente de certification" />
    <div class="p-4">
      <BaseCard>
        <BaseCardHeader>
          Patients en attente de certification
        </BaseCardHeader>
        <p class="p-4">
          Débloquez leur accès en certifiant leur numéro de mobile, ou en leur faisant scanner leur QR code depuis la
          fiche patient lors de leur prochaine visite
        </p>
        <v-data-table
          :headers="headers"
          :items="data ?? []"
          :loading="isLoading"
        >
          <template #[`item.action`]="{ item }">
            <div class="flex flex-row justify-end">
              <BaseButton
                v-if="!item?.certifications?.length"
                primary
                @click.stop="handleRowPress(item)"
              >
                Débloquer l'accès
              </BaseButton>
              <div v-else class="flex flex-row gap-2 items-center bg-orange-light p-2 rounded">
                <p>
                  En attente de validation patient
                </p>
                <InformationTooltip>
                  <p class="max-w-80">
                    Par mesure de sécurité, votre patient doit confirmer la certification sur son application avant de
                    pouvoir accéder à toutes les fonctionnalités.
                  </p>
                </InformationTooltip>
              </div>
            </div>
          </template>
        </v-data-table>
      </BaseCard>
      <customer-remote-certification
        v-if="modalVisible && userToCertify"
        :user="userToCertify"
        @close="modalVisible=false;"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
